<template>
  <div style="position: relative">
    <div class="checkDia" @click="isLogistics = true">查</div>
    <div v-for="(item, index) in inputData" :key="index" class="input_module">
      <span class="input_title">{{item.title}}</span>
      <span class="input_unit input_btn" v-if="index === 'packData'" @click="unitClick">英美制转换</span>
      <span class="input_unit" style="color: #19acfd;font-weight: bold" v-if="index === 'operatingExpenses'">(仅针对该商品)</span>
      <div v-for="(itemInput, i) in item.input" :key="i" class="input_content">
        <div v-if="itemInput.isShow" style="display: flex;position:relative;">
          <div :class="{input_name_1: index === 'packData', input_name_3: index === 'stockCost',
              input_name_2: index === 'operatingExpenses',
              input_name_5: index === 'sellerInfo', input_name_4: index === 'productRevenue'}">
            <span @mouseover="showDetail(index, i)" class="input_item_title" @mouseleave="cancelDetail(index, i)"
                  :class="{title_orange:itemInput.showDetail && itemInput.detail}">
              {{itemInput.name}}
              <template v-if="i === 'stockPrice'">
                <span class="curr_self" v-if="inputData.stockCost.input.xxts.data == 0">(含税)</span>
                <span class="curr_self" v-else>(不含税)</span>
              </template>
              <img v-if="itemInput.detail && i !== 'advertisingFee' " src="../img/问号.png" class="question-img">
              <!-- <span v-else>:</span> -->
              <span v-if="itemInput.showDetail && itemInput.detail && index !== 'productRevenue'" :style="{'width':itemInput.width}" :class="itemInput.name === '销售佣金率' ? 'input_item_detail2':'input_item_detail'">
                <div v-html="itemInput.detail"></div>
                <div v-if="itemInput.name === '销售佣金率'" style="margin-top: 5px;">
                  亚马逊类目VS销售佣金率：<br>
                  <div style="padding: 0 15px">
                    <ul>
                    <li>家居和园艺：15%；</li>
                    <li>厨具：15%；</li>
                    <li>办公用品：15%；</li>
                    <li>户外运动：15%</li>
                    <li>工具和家居整修：15%；</li>
                    <li>基础电动工具：12%；</li>
                    <li>3D打印商品：12%；</li>
                    <li>箱包和旅行用品：15%</li>
                    <li>家具和灯饰：15%；</li>
                    <li>乐器：15%；</li>
                    <li>个人电脑 ：6%；</li>
                    <li>宠物用品：15%；</li>
                    <li>玩具和游戏类：15%；</li>
                    <li>服装和配饰：17%；</li>
                    <li>图书收藏品：15%；</li>
                    <li>母婴商品不包括婴儿服饰：价格不超过$10是8%，价格超过$10是15%；</li>
                    <li>大型家电：总售价中$300以内15%；总售价中$300以上8%；</li>
                    <li>汽车和户外动力设备：汽车用品12%；轮胎和车轮商品为10%；</li>
                    <li>个护健康(含个人护理器具)：价格不超过$10是8%，价格超过$10是15%；</li>
                    <li>珠宝首饰：总售价中不超过$250是20%，总售价中超过$250是5%；</li>
                    <li>美容：价格不超过$10是8%，价格超过$10是15%；</li>
                    <li>食品类》价格不超过$15是8%，价格超过$15是15%；</li>
                    <li>钟表：总售价中不超过$1500是16%，总售价中超过$1500是3%；</li>
                    <li>鞋靴、手提包和太阳镜：总售价中不超过$75是15% ，总售价中超过$75是18%；</li>
                    <li>电子商品及配件：总售价中不超过$100是15% ，总售价中超过$100是8%；</li>
                  </ul>
                  </div>
                </div>
              </span>
              <span v-else-if="itemInput.showDetail && itemInput.detail !== '' && index === 'productRevenue'" :style="{'width':itemInput.width}" class="input_item_detail1">
                <div v-html="itemInput.detail"></div>
              </span>
            </span>

            <span v-if="i === 'advertisingFee' || i === 'sellingPrice'"
                  class="curr_self">({{countryCurrency_self[inputData.sellerInfo.input.countrySite.data]}})</span>
          </div>

          <label class="input_detail"  :class="{isInput: !itemInput.isInput}">
            <!-- <div v-if="itemInput.name === '国际总运费'" class="checkDia" @click="isLogistics = true">查</div> -->
            <div class="input_icon" :class="{special_icon: itemInput.icon[0] !== '￥'}"
                v-if="itemInput.type !== 'select' && (index === 'operatingExpenses' || index === 'productRevenue')">
              {{itemInput.icon[inputData.sellerInfo.input.countrySite.data]}}
            </div>
            <div v-else-if="itemInput.type=== 'select' && (index === 'sellerInfo' || i === 'sort' || i === 'sqbs')" style="display:none">

            </div>
            <div class="input_icon" :class="{special_icon: itemInput.icon[0] !== '￥'}"
                v-else>{{itemInput.icon[0]}}</div>

            <input class="disable_text" type="text" v-if="i === 'warehouseConfiguration' && inputData.sellerInfo.input.countrySite.data !== 0"
                    disabled v-model="text" autocomplete= "new-password">
            <select class="select_text" :name="item.title" id="0" v-else-if="itemInput.type=== 'select'" @change="optionClick(index,i)"
                    v-model="itemInput.data" @blur="selectBlur(itemInput.data,index,i)" :disabled="itemInput.isDisable"

                    :class="(index === 'sellerInfo' || i === 'sort')?'select_text1':'select_text'">
              <option :value="index1" v-for="(array, index1) in itemInput.array" :key="array" >{{array}}</option>
            </select>
            <input class="input_text" type="number" v-else v-model="itemInput.data" :disabled="itemInput.isDisable"
                  @blur="clearNumber(itemInput.data,index,i)" @focus="getInput(index, i)" autocomplete= "new-password">
            <span style="padding-top: 3px" v-if="i === 'operatingAnnualInterestRate' || i === 'recoveryLossRate' || i === 'commission' || i === 'salesCommission' || i === 'operationCommission' || i === 'sprkgsl'">%</span>
          </label>

          <div class="input_unit" v-if="index === 'packData'">{{itemInput.unit[unitIndex]}}</div>
          <div class="input_unit" v-else-if="index !== 'operatingExpenses' && index !== 'sellerInfo'">{{itemInput.unit[inputData.packData.input.unit.data]}}</div>
        </div>
      </div>
    </div>
<!--    <div class="bottom_end">-->
<!--      <span class="new_tips">提示：可点击保存按钮将数据保存到会员后台，方便以后快速及准确地核算商品的利润,进一步节省您的计算时间！</span>-->
      <div class="btn_right">
        <button class="calm_button" @click="importData">导入试用数据</button>
      <button class="calm_button" @click="clearClick">清&nbsp;空&nbsp;数&nbsp;据</button>
      <button class="calm_button" @click="calmClick">利&nbsp;润&nbsp;计&nbsp;算</button>
    </div>
<!--    </div>-->

    <calm-dialog :dialogShow="show" :isChange="false" @dialogShow="cancelDialog" @getUIndex="getUIndex" @cancelUpdate="cancelUpdate"
                 :input="inputData" :u-index="unitIndex" :need-update="isUpdate" :father-v-a-t="importVAT"></calm-dialog>
    <logistic v-show="isLogistics">

    </logistic>
  </div>
</template>

<script>
  import calmDialog from "@/views/home/components/content/calmDialog";
  import {request} from "@/network/request";
  import logistic from "@/views/home/components/content/logistics"

  // 亚马逊站点
  let country_self = ['美国站','加拿大站','英国站','德国站','法国站','意大利站','西班牙站','日本站','澳洲站', '墨西哥站'];
  // 不需要货币标识
  let noneCurrency_self = ['','','','','','','','','',];
  // 默认货币
  let defaultCurrency_self = ['￥','￥','￥','￥','￥','￥','￥','￥','￥','￥'];
  // 国家货币
  let nationalCurrency_self = ['$','CA$','￡','€','€','€','$','JP￥','AU$','MX$'];
  // 英制 / 美制长度转换
  let lengthArray_self = ['(cm)', '(inch)'];
  // 英制 / 美制重量转换
  let weightArray_self = ['(kg)', '(lb)'];
  // 默认单位
  let defaultArray_self = ['', ''];

  export default {
    name: "inputModule",
    components: {
      'calm-dialog': calmDialog,
      'logistic': logistic
    },
    data(){
      return{
         // 显示loading 图标
      showLoadingIcon: false,
      showLoadingIcon1: false,
      triVistable:false,
      triVistableType: 0,
        // 物流框
        isLogistics: false,
        // 增值税
        importVAT: 0,
        text: '无合仓设置',
        // 输入框计时器
        inputTimer: null,
        show: false,
        // 亚马逊站点
        country_self: ['美国站','加拿大站','英国站','德国站','法国站','意大利站','西班牙站','日本站','澳洲站', '墨西哥站'],
        // 不需要货币标识
        noneCurrency_self: ['','','','','','','','','',],
        // 默认货币
        defaultCurrency_self: ['￥','￥','￥','￥','￥','￥','￥','￥','￥','￥'],
        // 国家货币
        nationalCurrency_self: ['$','CA$','￡','€','€','€','$','JP￥','AU$','MX$'],
        // 英制 / 美制长度转换
        lengthArray_self: ['(cm)', '(inch)'],
        // 英制 / 美制重量转换
        weightArray_self: ['(kg)', '(lb)'],
        // 默认单位
        defaultArray_self: ['', ''],
        // 站点对应货币
        countryCurrency_self: ['美元','加元','英镑','欧元','欧元','欧元','欧元','日元','澳元', '比索'],
        // 当地运费
        ALShipping: 0,
        // 英美制进制索引
        unitIndex: 0,
        // 是否需要获取数据
        isUpdate: false,
        // 输入框数据
        inputData: {
          sellerInfo: {
            title: '站点及卖家账户信息',
            input: {
              countrySite: {
                name:'商品所属国家站点',
                type: 'select',
                unit: defaultArray_self,
                array: country_self,
                icon: noneCurrency_self,
                data: 0,
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              sellerType: {
                name:'卖家账户类型',
                type: 'select',
                unit: defaultArray_self,
                array: ['专业销售计划', '个人销售计划'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><section class="_135editor" data-role="paragraph"><p>亚马逊卖家分为“专业销售计划”及“个人销售计划”卖家。</p><p>(说明: 美国亚马逊“专业销售计划帐户”收费为每月$39.9，销售佣金另外计算；</p><p>美国亚马逊“个人销售计划帐户”收费为$0,但每套商品销售后收$0.99,销售佣金另外计算;</p><p>其它不同区域帐户收费类似）；</p><p><br></p><p>补充: 早前,亚马逊帐户分不同的区域帐户: 例如”北美区域帐户”包括美国,加拿大及墨西哥站点;</p><p>“欧盟区域帐户”包括德国，法国，西班牙，意大利站点; 英国脱欧后自成一”英国区域帐户;</p><p>日本与澳洲是另外两个独立的“日本区域帐户”及“澳洲区域帐户”，不同区域帐户各自收不同的卖家帐户月费；</p><p><br></p><p>但最近亚马逊实施了新政策, 对于“专业销售计划帐户”,所有不同的国家合并为1个卖家帐户,</p><p>统一只收$39.99月租费；但要注意的是,不同国家站点的帐户要合并设置后才能享受统一只收$39.99月租费；</p><p><br></p><p>“个人销售计划帐户”,收费保持不变；</p><p><br></p><p>备注：该项费用的分摊计算方法: 按整个卖家帐户的总销量来分摊到该商品上。</p><span>例如：该卖家帐户当月所有不同商品的总销量为100,那么该项费用将除以100计算该商品的分摊成本。</span></section></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              warehouseConfiguration: {
                name:'合仓设置',
                type: 'select',
                unit: defaultArray_self,
                array: ['已合仓', '未合仓'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>当货物有N箱进行亚马逊FBA入仓计划时,亚马逊可能对该批货物安排进入N个不同仓库，</p><p>这样导致的结果是您将需要将该批货物分为N批次货物各自发运到不同的仓库地址,</p><p>国际物流运费成本及安排发运的操作成本自然地将大大增加。</p><p><br></p><p>为解决这个问题,亚马逊相应地提供”合仓配置“的功能,让该批货物可以合并发到同一个亚马逊仓库,</p><p>但同时亚马逊将针对“该批货物中的每一个商品收取”合仓配置费”。根据不同的商品分类,及其尺寸,</p><p>重量,类型等分为标准件,大件,超大件等收取不同的”合仓配置费”。</p><p><br></p><p>我们系统已根据您录入的商品信息,智能分析及计算出每套商品的”合仓配置费”,放请心使用。</p><p><br></p><p>温馨提示:每次发货的箱数不同,亚马逊将货物分配到多少个不同仓库难以确定,这个通常做了进仓计划后</p><p>才有确切数据。理论上卖家可根据两种情况下的“国际物流运费差”对比“该批货物被收取的总合仓配置费”</p><p>才能确认那个更划算。但实际上,合仓与不合仓设置得不断重设置,同时进仓计划要不停地放弃,这样会</p><p>影响亚马逊店铺的绩效分数。因此我们不建议合仓设置经常切换。当然,只有一两箱货物做进仓计划时</p><p>通常会安排到同一个仓库;视情况而定,对于不同的货物,卖家如果有时间可计算比较一下！</p><p><br></p><p>对于初级卖家,建议为了简单操作，设置为合仓为宜！</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              otherFee: {
                name: '独立网络等运营月费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>根据卖家不同的运营方式及阶段,亚马逊卖家帐户“独立网络等运营月费”将包括: 独立IP网络的使用月费,</p><p>辅助运营软件月费及其它费用(如果不产生该项费用,可视费用为0)；</p><p><br></p><p>备注：该项费用的分摊计算方法与“卖家类型”的分摊方式一致:按整个卖家帐户的总销量来分摊到该商品上。</p><p>例如：该卖家帐户当月所有不同商品的总销量为100,那么该项费用将除以100计算该商品的分摊成本。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              taxExpense: {
                name: '卖家帐户月均财务费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>由于欧盟的税务要求非常严格,通常亚马逊卖家的商品入欧盟成员国及英国的亚马逊仓库并</p><p>进行销售时都需要申请注册当地公司(欧盟成员国及英国当地个人卖家在一定的年销售总额下例外)</p><p>并通过专业的会计师做帐,年审,报税等。因此每年产生一定的财务费用。按月平均分摊将产生该</p><p>“卖家帐户月均账务费”;</p><p><br></p><p>(备注:英国每3个月一次,1年共4次VAT申报; 意大利及西班牙每季节1次,年度1次,共5次VAT申报;</p><p>法国每月1次,1年共12次VAT申报;例如财务公司对英国帐户每年收取的做帐及VAT申报等财务费为</p><p>￥12000;即卖家帐户月均财务费为￥1000;</p><p><br></p><p>此项费用通常适用于英国及其它欧盟成员国; 美国,加拿大,日本,澳洲等国家通常不涉及此项费用;</p><p>但视实际情况而定,该项费用可按实际录入数据)；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width: '540px'
              },
              operatingAnnualInterestRate: {
                name: '资金运营年息率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>该年息率用于计算亚马逊采购及物流等的资金运营成本。该项为预设值，请到“设置/店铺与帐户设置”目录页内进行预设置，对应数据才会在此自动导出。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
            }
          },
          packData:{
            title: '单个商品包装数据',
            input:{
              long: {
                name: '长',
                type: 'number',
                unit: lengthArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              width: {
                name: '宽',
                type: 'number',
                unit: lengthArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              height: {
                name: '高',
                type: 'number',
                unit: lengthArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              weight:{
                name: '重量',
                type: 'number',
                unit: weightArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              sort: {
                name: '商品分类',
                type: 'select',
                unit: defaultArray_self,
                array: ['非服装,鞋靴，箱包分类', '服装，鞋靴，箱包分类'],
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              unit: {
                name: '计价单位',
                type: 'select',
                unit: defaultArray_self,
                array: ['套', '个', '盒', '包', '袋', '支'],
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
            }
          },
          stockCost: {
            title: '商品采购及物流成本',
            input: {
              xxts:{
                name: '是否出口退税',
                type: 'select',
                unit: defaultArray_self,
                array:['是','否'],
                icon: noneCurrency_self,
                data: 1,
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              sqbs:{
                name: '清关及缴税状况',
                type: 'select',
                array:['双清包税','双清不包税'],
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: 0,
                // detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              stockPrice: {
                name: '采购单价',
                type: 'number',
                unit: ['(/套)', '(/个)', '(/盒)', '(/包)', '(/袋)', '(/支)'],
                icon: defaultCurrency_self,
                data: '',
                detail:'对于贸易公司或个人，这里就是产品的采购单价；对于生产厂家，这里可以理解为产品的出厂单价；',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              stockNum: {
                name: '采购数量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail:'对于贸易公司或个人，这里就是产品的采购数量；；对于生产厂家，这里可以理解为产品的生产数量；',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              domesticFreight: {
                name: '国内段总运费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指基于以上采购数量,该批商品自己安排发货而产生的国内段运费; 如果国际货运公司免费上门收件,</p><p>该国内总运费可视为0,在单元格数据可输入0即可；</p><p><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              internationFreight: {
                name: '国际段总运费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              saleTax: {
                name: '海关申报单价',
                type: 'number',
                unit: ['(/套)', '(/个)', '(/盒)', '(/包)', '(/袋)', '(/支)'],
                icon: defaultCurrency_self,
                data: '',
                detail: '海关申报单价主要用于目的港清关,根据货物申报价值计算目的国入口关税等;',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'420px'
              },
              sprkgsl: {
                name: '商品入口关税率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              importTariff: {
                name: '货物入口税费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '由于商品的多样性及复杂性,即使出口国对该商品归类为某对应的商品海关编码(HS CODE),但终究以进口国对该进口商品进行审核及判断商品的归类及价值为准。因此商品入口关税难以准确预测，但可以试归类对应HS Code及关税率，预估入口关税额；如果该商品曾经出口，可咨询清关代理确认当时的入口关税并直接在此录入；<br><br>对于某些国家例如日本的物流渠道，通常只提供双清不包税，入口关税只按实报实销原则向货主收取(您可按物流公司的实收金额数值输入到单元格即可）。对于DDP双清包税的物流渠道,由于已包含清关关税,这种情况下可以在单元格内输入0。',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'520px'
              }
            }
          },
          operatingExpenses: {
            title: '商品当月运营费用',
            input: {
              advertisingFee: {
                name: '当月站内广告费',
                type: 'number',
                unit: defaultArray_self,
                icon: nationalCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指“该商品当月的”亚马逊站内的点击广告费”;可在亚马逊后台“广告管理”内查询该商品的当月点击</p><p>广告费用。如不涉及这项费用,在单元格数据可以输入0；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              dealFee: {
                name: '当月站内Deal费用',
                type: 'number',
                unit: defaultArray_self,
                icon: nationalCurrency_self,
                data: '0',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: false,
                isDisable: false,
              },
              couponFee: {
                name: '当月站内Coupon费用',
                type: 'number',
                unit: defaultArray_self,
                icon: nationalCurrency_self,
                data: '0',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: false,
                isDisable: false,
              },
              billingFee: {
                name: '当月站外测评费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指该商品当月亚马逊站外的“测评实际损耗”(此测评基于商品免费提供及不回收的情况）。</p><p><br></p><p>“当月站外测评费”的参考计算公式：</p><p>当月站外测评费 = （该商品的采购成本 + 国内单位运费 + 国际单位运费 +</p><p>合仓配置费 + 当地运费 + 亚马逊佣金 + 测评服务费）* 该商品的测试数量；</p><p><br></p><p>如果商品有其它不同的测评方式，例如：不同的留评比率或可回收商品等,请根据您的实际情况</p><p>输入相应的当月站外测评费);如不涉及这项提成,可以输入0；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              drainageFee: {
                name: '当月站外引流费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指由亚马逊站外的渠道推广引流的月费，例如通过Facebook, Google或其它网站的点击广告或</p><p>其它运营操作引流到该亚马逊在售商品所产生的费用;如不涉及这项费用,可以输入0；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              salesCommission: {
                name: '商品销售提成率',
                type: 'number',
                array: ['0.0%','0.5%', '1.0%', '1.5%', '2.0%', '2.5%', '3.0%', '3.5%', '4.0%', '4.5%',
                  '5.0%', '5.5%', '6.0%', '6.5%', '7.0%', '7.5%', '8.0%', '8.5%', '9.0%', '9.5%', '10.0%'],
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指基于"商品售价"的销售提成率（此项是为店铺销售人员设置的对于当前商品的销售提成率；此项为预设置项，如要修改，请先到“设置/商品销售提成设置”目录页对应修改更新);</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              operationCommission: {
                name: '运营管理提成率',
                type: 'number',
                array: ['0.0%','0.5%', '1.0%', '1.5%', '2.0%', '2.5%', '3.0%', '3.5%', '4.0%', '4.5%',
                  '5.0%', '5.5%', '6.0%', '6.5%', '7.0%', '7.5%', '8.0%', '8.5%', '9.0%', '9.5%', '10.0%'],
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指也是基于“商品售价”的运营管理提成率（此项是为“亚马逊多店铺运营管理人员”设置的针对“所有店铺商品”“统一的销售提成率”；如您的亚马逊销售体量较大，已涉及运营管理人员，或者您的亚马逊是通过代运营管理，可以考虑设置该项提成；此项为预设置项，如要修改，请先到“设置/店铺及费用设置”目录页对应修改更新);</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              commission: {
                name: '亚马逊销售佣金率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指亚马逊对商品抽取的“销售佣金率”（此项为预设置项，如要修改，请先到“销售/Listing管理”目录页查找对应商品信息进行“商品销售佣金率”的修改更新);</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              recoveryLossRate: {
                name: '收汇损失率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>该收汇损失率可根据您所合作的收汇公司实际收取的服务费率设置 (该项为预设值，请到“设置/店铺运营管理提成设置”目录页内进行预设置，对应数据才会在此自动导出)。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'480px'
              },
            }
          },
          productRevenue: {
            title: '商品售价,销量,退货量,仓储,汇损',
            input: {
              sellingPrice: {
                name: '商品售价',
                type: 'number',
                unit: ['(/套)', '(/个)', '(/盒)', '(/包)', '(/袋)', '(/支)'],
                icon: nationalCurrency_self,
                data: 0,
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              showSales: {
                name: '当月显示销量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>可根据这个路径:“亚马逊后台/数据报告/业务报告/根据ASIN及日期筛选及查询显示的销售量”</p><p><br></p><p>注意:</p><p style="margin-left:0;text-indent:0">1. 商品销售量与订单量不同,1个订单可能有N个商品；</p><p style="margin-left:0;text-indent:0">2. 在显示商品Listing销售量的页面,有些订单是坏品弃置的记录单,注意辨识及减除；</p><p><br></p><p>我们系统内还有另外一项“当月实际销量”，当月实际销量 = 当月销量 - 当月坏品退货数 - 当月非坏品退货数</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'500px'
              },
              disposalNum: {
                name: '当月坏品退货数',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>坏品退货数查询路径：</p><p style="margin-left:0;text-indent:0">1. 亚马逊后台 / 库存 / 管理亚马逊库存 / 库存控制面板 / 管理亚马逊物流退货; 或</p><p style="margin-left:0;text-indent:0">2. 亚马逊后台 / 数据报告 / 退货报告 / 查看亚马逊物流报告 / 亚马逊物流买家退货;</p><p><br></p><p>通过对应的国家,ASIN及“最近30日”筛选出相应的商品及统计“库存属性”为“Customer Damaged买家导致的残损”及“Defective存在瑕疵”的坏品的总退货数量,在单元格输入即可)；&nbsp;</p><p><br></p><p>(备注:商品退回亚马逊仓库后亚马逊会对商品进行检查及进行“库存属性”的定性。当定性为“买家导致的残损”及“存在瑕疵”,商品将在一定天数后才安排坏品弃置。</p><p><br></p><p>补充:</p><p>1套“库存属性”定性为“买家导致的残损”及“存在瑕疵”的坏品退货的实际损失 =</p><p>商品的采购成本 + 国内运费 + 国际运费 + 合仓配置费 + 仓储成本 + 亚马逊卖家帐户月费分摊 +</p><p>月广告费用分摊 + 月测试费用分摊 + 站外月引流费用分摊 + 当地运费+亚马逊佣金；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              returnNum: {
                name: '当月非坏品退货数',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: 0,
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>非坏品退货数查询路径:</p><p style="margin-left:0;text-indent:0">1. 亚马逊后台 / 库存 / 管理亚马逊库存 / 库存控制面板/管理亚马逊物流退货; 或</p><p style="margin-left:0;text-indent:0">2. 亚马逊后台 / 数据报告 / 退货报告 / 查看亚马逊物流报告 / 亚马逊物流买家退货;</p><p><br></p><p>通过对应的国家,ASIN及“最近30日”筛选出相应的商品及统计“库存属性”为“Sellable可售”的非坏品的总退货数量,</p><p>在单元格输入即可)；</p><p><br></p><p>(备注:商品退回亚马逊仓库后亚马逊会对商品进行检查及进行“库存属性”的定性。当定性为“Sellable可售”,</p><p>商品将会被亚马逊重新安排上架及作为Used二手货物降价,以跟卖的方式销售。</p><p><br></p><p>补充：</p><p>1套“Sellable可售”的非坏品退货的实际损失 =</p><p>该商品售价的亚马逊销售佣金部分的20% + 当地运费 + 25% &nbsp;* 商品售价 * （1 - 亚马逊佣金率)；</p><p>(备注：此项计算基于粗略假设亚马逊将商品降价25%重新上架销售)</p></section>',
                showDetail: false,
                isInput: true,
                isShow: false,
                isDisable: false,
              },
              dyqzycsl: {
                name: '当月弃置移除数量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" class="article135" label="edit by 135editor"><p>备注：由于亚马逊的区域移除报告不提供对应的国家站点数据，该单元格取值按“区域移除数据报告”对应的的这个ASIN的移除数量除以“该区域已开通的国家站点的数量”；数据默认进位为整数；</p><section class="_135editor" data-role="paragraph"><p><br></p></section></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },

              positionDay: {
                name: '商品当前库存量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>根据这个链接: <a href="https://sellercentral.amazon.com/inventory">https://sellercentral.amazon.com/inventory</a>;</p><p>或根据这个路径: 亚马逊后台 / 库存 / 对应商品的ASIN查询该商品的当前库存数量即可。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'480px'
              },
              dybpcsl: {
                name: '当月赔偿回款',
                type: 'number',
                unit: [],
                icon: nationalCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              // commission: {
              //   name: '亚马逊销售佣金率',
              //   type: 'number',
              //   unit: defaultArray_self,
              //   icon: noneCurrency_self,
              //   data: '',
              //   detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指亚马逊对该商品收取的销售佣金率。根据路径: “亚马逊后台销售中心/库存/库存管理”目录页查找对应的商品Listing的“销售佣金”,再用“销售佣金”除以“商品售价”就可得出“销售佣金率”，然后输入到本单元格即可。</p><p><br></p><p>(补充: 1.通常,商品的佣金率很少变化，一旦确定，卖家在商品以后的销售运营过程中修改商品售价时将不影响本系统自动计算实际佣金额，这样将有利于系统准确计算商品及店铺利润。2.对于还没有在亚马逊后台创建商品Listing的选品阶段, 卖家可在后台查询亚马逊类目及对应的佣金率,输入到本单元格即可快速进行商品预算)</p></section>',
              //   showDetail: false,
              //   isInput: true,
              //   isShow: true,
              //   isDisable: false,
              // },

            }
          },
        }
      }
    },
    methods: {
      // 卖家固定费用按钮点击事件
      clickmjgdfy(index){
        this.showLoadingIcon = true
        let timer = setTimeout(() => {
          this.showLoadingIcon = false
          this.calType = index
          clearTimeout(timer)
        }, 200)
      },
      clickmjgdfy1(){
        this.showLoadingIcon1 = true
        let timer = setTimeout(() => {
          this.showLoadingIcon1 = false
          clearTimeout(timer)
        }, 200)
      },
      openTriVis(type){
        this.triVistable = true
        this.triVistableType = type
      },
      //禁止滚动
      stop(){
        var mo=function(e){
          e.preventDefault();
        };
        document.body.style.overflow='hidden';
        document.addEventListener("touchmove",mo,false);//禁止页面滑动
      },
      // 导入数据
      importData(){
        this.inputData = {
          sellerInfo: {
            title: '站点及卖家账户信息',
            input: {
              countrySite: {
                name:'商品所属国家站点',
                type: 'select',
                unit: defaultArray_self,
                array: country_self,
                icon: noneCurrency_self,
                data: 0,
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              sellerType: {
                name:'卖家账户类型',
                type: 'select',
                unit: defaultArray_self,
                array: ['专业销售计划', '个人销售计划'],
                icon: noneCurrency_self,
                data: 0,
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><section class="_135editor" data-role="paragraph"><p>亚马逊卖家分为“专业销售计划”及“个人销售计划”卖家。</p><p>(说明: 美国亚马逊“专业销售计划帐户”收费为每月$39.9，销售佣金另外计算；</p><p>美国亚马逊“个人销售计划帐户”收费为$0,但每套商品销售后收$0.99,销售佣金另外计算;</p><p>其它不同区域帐户收费类似）；</p><p><br></p><p>补充: 早前,亚马逊帐户分不同的区域帐户: 例如”北美区域帐户”包括美国,加拿大及墨西哥站点;</p><p>“欧盟区域帐户”包括德国，法国，西班牙，意大利站点; 英国脱欧后自成一”英国区域帐户;</p><p>日本与澳洲是另外两个独立的“日本区域帐户”及“澳洲区域帐户”，不同区域帐户各自收不同的卖家帐户月费；</p><p><br></p><p>但最近亚马逊实施了新政策, 对于“专业销售计划帐户”,所有不同的国家合并为1个卖家帐户,</p><p>统一只收$39.99月租费；但要注意的是,不同国家站点的帐户要合并设置后才能享受统一只收$39.99月租费；</p><p><br></p><p>“个人销售计划帐户”,收费保持不变；</p><p><br></p><p>备注：该项费用的分摊计算方法: 按整个卖家帐户的总销量来分摊到该商品上。</p><span  >例如：该卖家帐户当月所有不同商品的总销量为100,那么该项费用将除以100计算该商品的分摊成本。</span></section></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              warehouseConfiguration: {
                name:'合仓设置',
                type: 'select',
                unit: defaultArray_self,
                array: ['已合仓', '未合仓'],
                icon: noneCurrency_self,
                data: 1,
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>当货物有N箱进行亚马逊FBA入仓计划时,亚马逊可能对该批货物安排进入N个不同仓库，</p><p>这样导致的结果是您将需要将该批货物分为N批次货物各自发运到不同的仓库地址,</p><p>国际物流运费成本及安排发运的操作成本自然地将大大增加。</p><p><br></p><p>为解决这个问题,亚马逊相应地提供”合仓配置“的功能,让该批货物可以合并发到同一个亚马逊仓库,</p><p>但同时亚马逊将针对“该批货物中的每一个商品收取”合仓配置费”。根据不同的商品分类,及其尺寸,</p><p>重量,类型等分为标准件,大件,超大件等收取不同的”合仓配置费”。</p><p><br></p><p>我们系统已根据您录入的商品信息,智能分析及计算出每套商品的”合仓配置费”,放请心使用。</p><p><br></p><p>温馨提示:每次发货的箱数不同,亚马逊将货物分配到多少个不同仓库难以确定,这个通常做了进仓计划后</p><p>才有确切数据。理论上卖家可根据两种情况下的“国际物流运费差”对比“该批货物被收取的总合仓配置费”</p><p>才能确认那个更划算。但实际上,合仓与不合仓设置得不断重设置,同时进仓计划要不停地放弃,这样会</p><p>影响亚马逊店铺的绩效分数。因此我们不建议合仓设置经常切换。当然,只有一两箱货物做进仓计划时</p><p>通常会安排到同一个仓库;视情况而定,对于不同的货物,卖家如果有时间可计算比较一下！</p><p><br></p><p>对于初级卖家,建议为了简单操作，设置为合仓为宜！</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              otherFee: {
                name: '独立网络等运营月费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '80',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>根据卖家不同的运营方式及阶段,亚马逊卖家帐户“独立网络等运营月费”将包括: 独立IP网络的使用月费,</p><p>辅助运营软件月费及其它费用(如果不产生该项费用,可视费用为0)；</p><p><br></p><p>备注：该项费用的分摊计算方法与“卖家类型”的分摊方式一致:按整个卖家帐户的总销量来分摊到该商品上。</p><p>例如：该卖家帐户当月所有不同商品的总销量为100,那么该项费用将除以100计算该商品的分摊成本。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              taxExpense: {
                name: '卖家帐户月均财务费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '0',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>由于欧盟的税务要求非常严格,通常亚马逊卖家的商品入欧盟成员国及英国的亚马逊仓库并</p><p>进行销售时都需要申请注册当地公司(欧盟成员国及英国当地个人卖家在一定的年销售总额下例外)</p><p>并通过专业的会计师做帐,年审,报税等。因此每年产生一定的财务费用。按月平均分摊将产生该</p><p>“卖家帐户月均账务费”;</p><p><br></p><p>(备注:英国每3个月一次,1年共4次VAT申报; 意大利及西班牙每季节1次,年度1次,共5次VAT申报;</p><p>法国每月1次,1年共12次VAT申报;例如财务公司对英国帐户每年收取的做帐及VAT申报等财务费为</p><p>￥12000;即卖家帐户月均财务费为￥1000;</p><p><br></p><p>此项费用通常适用于英国及其它欧盟成员国; 美国,加拿大,日本,澳洲等国家通常不涉及此项费用;</p><p>但视实际情况而定,该项费用可按实际录入数据)；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width: '540px'
              },
              operatingAnnualInterestRate: {
                name: '资金运营年息率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '5.0',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>该年利息率用于计算亚马逊商品采购及物流的资金使用成本。如果资金是来自银行贷款，您可以在此直接输入贷款的年利息率；如果是自有资金，可以输入当前银行的存款利息率；或者根据实际情况输入相应的数据，当然您也可以忽略资金的使用成本，输入0%即可.</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
            }
          },
          packData:{
            title: '单个商品包装数据',
            input:{
              long: {
                name: '长',
                type: 'number',
                unit: lengthArray_self,
                icon: noneCurrency_self,
                data: '32.5',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              width: {
                name: '宽',
                type: 'number',
                unit: lengthArray_self,
                icon: noneCurrency_self,
                data: '13.5',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              height: {
                name: '高',
                type: 'number',
                unit: lengthArray_self,
                icon: noneCurrency_self,
                data: '10.0',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              weight:{
                name: '重量',
                type: 'number',
                unit: weightArray_self,
                icon: noneCurrency_self,
                data: '1.00',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              sort: {
                name: '商品分类',
                type: 'select',
                unit: defaultArray_self,
                array: ['非服装,鞋靴，箱包分类', '服装，鞋靴，箱包分类'],
                icon: noneCurrency_self,
                data: '0',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              unit: {
                name: '计价单位',
                type: 'select',
                unit: defaultArray_self,
                array: ['套', '个', '盒', '包', '袋', '支'],
                icon: noneCurrency_self,
                data: 0,
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
            }
          },
          stockCost: {
            title: '商品采购及物流成本',
            input: {
              xxts:{
                name: '是否出口退税',
                type: 'select',
                unit: defaultArray_self,
                array:['是','否'],
                icon: noneCurrency_self,
                data: 1,
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              sqbs:{
                name: '清关及缴税状况',
                type: 'select',
                array:['双清包税','双清不包税'],
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: 0,
                // detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              stockPrice: {
                name: '采购单价',
                type: 'number',
                unit: ['(/套)', '(/个)', '(/盒)', '(/包)', '(/袋)', '(/支)'],
                icon: defaultCurrency_self,
                data: '80',
                detail: '对于贸易公司或个人，这里就是产品的采购单价；对于生产厂家，这里可以理解为产品的出厂单价；',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              stockNum: {
                name: '采购数量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '300',
                detail: '对于贸易公司或个人，这里就是产品的采购数量；；对于生产厂家，这里可以理解为产品的生产数量；',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              domesticFreight: {
                name: '国内段总运费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '300',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指基于以上采购数量,该批商品自己安排发货而产生的国内段运费; 如果国际货运公司免费上门收件,</p><p>该国内总运费可视为0,在单元格数据可输入0即可；</p><p><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              internationFreight: {
                name: '国际段总运费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '4500',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              saleTax: {
                name: '海关申报单价',
                type: 'number',
                unit: ['(/套)', '(/个)', '(/盒)', '(/包)', '(/袋)', '(/支)'],
                icon: defaultCurrency_self,
                data: '75.00',
                detail: '海关申报单价主要用于目的港清关,根据货物申报价值计算目的国入口关税等;',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'420px'
              },
              sprkgsl: {
                name: '商品入口关税率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '0',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              importTariff: {
                name: '货物入口税费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '0',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>由于商品的多样性及复杂性,即使出口国对该商品归类为某对应的商品海关编码(HS CODE),</p><p>但终究以进口国对该进口商品进行审核及判断商品的归类及价值为准。因此商品入口关税</p><p>难以准确预测，但可以试归类对应HS Code及关税率，预估入口关税额；</p><p>如果该商品曾经出口，可咨询清关代理确认当时的入口关税并直接在此录入；</p><p><br></p><p>对于某些国家例如日本的物流渠道，通常只提供双清不包税，入口关税只按实报实销原则向货主收取</p><p>(您可按物流公司的实收金额数值输入到单元格即可）。对于DDP双清包税的物流渠道,由于已包含清关关税,</p><p>这种情况下可以在单元格内输入0。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'520px'
              }
            }
          },
          operatingExpenses: {
            title: '商品当月运营费用',
            input: {
              advertisingFee: {
                name: '当月站内广告费',
                type: 'number',
                unit: defaultArray_self,
                icon: nationalCurrency_self,
                data: '100',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指“该商品当月的”亚马逊站内的点击广告费”;可在亚马逊后台“广告管理”内查询该商品的当月点击</p><p>广告费用。如不涉及这项费用,在单元格数据可以输入0；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              dealFee: {
                name: '当月站内Deal费用',
                type: 'number',
                unit: defaultArray_self,
                icon: nationalCurrency_self,
                data: '0',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: false,
                isDisable: false,
              },
              couponFee: {
                name: '当月站内Coupon费用',
                type: 'number',
                unit: defaultArray_self,
                icon: nationalCurrency_self,
                data: '0',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: false,
                isDisable: false,
              },
              billingFee: {
                name: '当月站外测评费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '600',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指该商品当月亚马逊站外的“测评实际损耗”(此测评基于商品免费提供及不回收的情况）。</p><p><br></p><p>“当月站外测评费”的参考计算公式：</p><p>当月站外测评费 = （该商品的采购成本 + 国内单位运费 + 国际单位运费 +</p><p>合仓配置费 + 当地运费 + 亚马逊佣金 + 测评服务费）* 该商品的测试数量；</p><p><br></p><p>如果商品有其它不同的测评方式，例如：不同的留评比率或可回收商品等,请根据您的实际情况</p><p>输入相应的当月站外测评费);如不涉及这项提成,可以输入0；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              drainageFee: {
                name: '当月站外引流费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '0',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指由亚马逊站外的渠道推广引流的月费，例如通过Facebook, Google或其它网站的点击广告或</p><p>其它运营操作引流到该亚马逊在售商品所产生的费用;如不涉及这项费用,可以输入0；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              salesCommission: {
                name: '商品销售提成率',
                type: 'number',
                array: ['0.0%','0.5%', '1.0%', '1.5%', '2.0%', '2.5%', '3.0%', '3.5%', '4.0%', '4.5%',
                  '5.0%', '5.5%', '6.0%', '6.5%', '7.0%', '7.5%', '8.0%', '8.5%', '9.0%', '9.5%', '10.0%'],
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '2',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指基于“商品售价”的销售提成率(此项是为店铺销售员设置的提成率,特意为运营较多亚马逊店铺</p><p>帐户及管理多名店铺销售员，并且考虑为不同商品在不同阶段配合销售，弹性设置提成率而设置); 如不涉及这项提成,可以输入0;</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              operationCommission: {
                name: '运营管理提成率',
                type: 'number',
                array: ['0.0%','0.5%', '1.0%', '1.5%', '2.0%', '2.5%', '3.0%', '3.5%', '4.0%', '4.5%',
                  '5.0%', '5.5%', '6.0%', '6.5%', '7.0%', '7.5%', '8.0%', '8.5%', '9.0%', '9.5%', '10.0%'],
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '2',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指基于“商品售价”的运营管理提成率(此项是为多亚马逊店铺帐户运营下涉及运营管理人员或合</p><p>作借用该账户而提供的“综合提成率”,如不涉及这项提成,可以输入0)；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              commission: {
                name: '亚马逊销售佣金率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '15.0',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指亚马逊对该商品收取的销售佣金率。根据路径: “亚马逊后台销售中心/库存/库存管理”目录页查找对应的商品Listing的“销售佣金”,再用“销售佣金”除以“商品售价”就可得出“销售佣金率”，然后输入到本单元格即可。</p><p><br></p><p>(补充: 1.通常,商品的佣金率很少变化，一旦确定，卖家在商品以后的销售运营过程中修改商品售价时将不影响本系统自动计算实际佣金额，这样将有利于系统准确计算商品及店铺利润。2.对于还没有在亚马逊后台创建商品Listing的选品阶段, 卖家可在后台查询亚马逊类目及对应的佣金率,输入到本单元格即可快速进行商品预算)</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              recoveryLossRate: {
                name: '收汇损失率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '2.0',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>该收汇损失率可根据您所合作的收汇公司实际收取的服务费率设置 (该项为预设值，请到“设置/店铺运营管理提成设置”目录页内进行预设置，对应数据才会在此自动导出)。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'480px'
              },
            }
          },
          productRevenue: {
            title: '商品售价,销量,退货量,仓储,汇损',
            input: {
              sellingPrice: {
                name: '商品售价',
                type: 'number',
                unit: ['(/套)', '(/个)', '(/盒)', '(/包)', '(/袋)', '(/支)'],
                icon: nationalCurrency_self,
                data: '37.50',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              showSales: {
                name: '当月显示销量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '150',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>可根据这个路径:“亚马逊后台/数据报告/业务报告/根据ASIN及日期筛选及查询显示的销售量”</p><p><br></p><p>注意:</p><p style="margin-left:0;text-indent:0">1. 商品销售量与订单量不同,1个订单可能有N个商品；</p><p style="margin-left:0;text-indent:0">2. 在显示商品Listing销售量的页面,有些订单是坏品弃置的记录单,注意辨识及减除；</p><p><br></p><p>我们系统内还有另外一项“当月实际销量”，当月实际销量 = 当月销量 - 当月坏品退货数 - 当月非坏品退货数</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'500px'
              },
              disposalNum: {
                name: '当月坏品退货数',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '6',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>坏品退货数查询路径：</p><p style="margin-left:0;text-indent:0">1. 亚马逊后台 / 库存 / 管理亚马逊库存 / 库存控制面板 / 管理亚马逊物流退货; 或</p><p style="margin-left:0;text-indent:0">2. 亚马逊后台 / 数据报告 / 退货报告 / 查看亚马逊物流报告 / 亚马逊物流买家退货;</p><p><br></p><p>通过对应的国家,ASIN及“最近30日”筛选出相应的商品及统计“库存属性”为“Customer Damaged买家导致的残损”及“Defective存在瑕疵”的坏品的总退货数量,在单元格输入即可)；&nbsp;</p><p><br></p><p>(备注:商品退回亚马逊仓库后亚马逊会对商品进行检查及进行“库存属性”的定性。当定性为“买家导致的残损”及“存在瑕疵”,商品将在一定天数后才安排坏品弃置。</p><p><br></p><p>补充:</p><p>1套“库存属性”定性为“买家导致的残损”及“存在瑕疵”的坏品退货的实际损失 =</p><p>商品的采购成本 + 国内运费 + 国际运费 + 合仓配置费 + 仓储成本 + 亚马逊卖家帐户月费分摊 +</p><p>月广告费用分摊 + 月测试费用分摊 + 站外月引流费用分摊 + 当地运费+亚马逊佣金；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              returnNum: {
                name: '当月弃置移除数量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: 5,
                detail: '<section data-role="outer" class="article135" label="edit by 135editor"><p>备注：由于亚马逊的区域移除报告不提供对应的国家站点数据，该单元格取值按“区域移除数据报告”对应的的这个ASIN的移除数量除以“该区域已开通的国家站点的数量”；数据默认进位为整数；</p><section class="_135editor" data-role="paragraph"><p><br></p></section></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              dyqzycsl: {
                name: '当月非坏品退货数',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: 5,
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>非坏品退货数查询路径:</p><p style="margin-left:0;text-indent:0">1. 亚马逊后台 / 库存 / 管理亚马逊库存 / 库存控制面板/管理亚马逊物流退货; 或</p><p style="margin-left:0;text-indent:0">2. 亚马逊后台 / 数据报告 / 退货报告 / 查看亚马逊物流报告 / 亚马逊物流买家退货;</p><p><br></p><p>通过对应的国家,ASIN及“最近30日”筛选出相应的商品及统计“库存属性”为“Sellable可售”的非坏品的总退货数量,</p><p>在单元格输入即可)；</p><p><br></p><p>(备注:商品退回亚马逊仓库后亚马逊会对商品进行检查及进行“库存属性”的定性。当定性为“Sellable可售”,</p><p>商品将会被亚马逊重新安排上架及作为Used二手货物降价,以跟卖的方式销售。</p><p><br></p><p>补充：</p><p>1套“Sellable可售”的非坏品退货的实际损失 =</p><p>该商品售价的亚马逊销售佣金部分的20% + 当地运费 + 25% &nbsp;* 商品售价 * （1 - 亚马逊佣金率)；</p><p>(备注：此项计算基于粗略假设亚马逊将商品降价25%重新上架销售)</p></section>',
                showDetail: false,
                isInput: true,
                isShow: false,
                isDisable: false,
              },
              positionDay: {
                name: '商品当前库存量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '400',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>根据这个链接: <a href="https://sellercentral.amazon.com/inventory">https://sellercentral.amazon.com/inventory</a>;</p><p>或根据这个路径: 亚马逊后台 / 库存 / 对应商品的ASIN查询该商品的当前库存数量即可。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'480px'
              },
              dybpcsl: {
                name: '当月赔偿回款',
                type: 'number',
                unit: [],
                icon: nationalCurrency_self,
                data: 0,
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
            }
          },
        }
        request({
          url: '/support-server/log/visit/homeCalculateImport',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
        })
      },
      clearClick(){
        this.inputData = this.$options.data().inputData
      },
      getInput(index ,i){
        if(i === 'long' || i === 'width' || i === 'weight' || i === 'height'){
          this.isUpdate = true
        }else {
          this.isUpdate = false
        }
      },
      getUIndex(ui){
        this.unitIndex = ui
      },
      cancelUpdate(bool){
        this.isUpdate = bool
      },
      // 显示输入款细节
      showDetail(index, i){
        let that = this
        clearTimeout(that.inputTimer)
        this.inputTimer = setTimeout(() => {
          that.inputData[index].input[i].showDetail = true
        }, 500)
      },
      // 隐藏输入框细节
      cancelDetail(index, i){
        clearTimeout(this.inputTimer)
        this.inputTimer = null
        this.inputData[index].input[i].showDetail = false
      },
      // 显示弹窗
      calmClick(){
        // console.log(this.inputData.sellerInfo.input.sellerType.data)
        this.stop()
        let isError = false;
        for (let i in this.inputData){
          for (let j in this.inputData[i].input){
            if(this.inputData[i].input[j].isShow){
              if(!this.inputData[i].input[j].data && this.inputData[i].input[j].data !== 0) {
                this.inputData[i].input[j].isInput = false;
                isError = true;
              }
            }
          }
        }
        if(isError)
          alert('请将信息补充完整');
        else{
          request({
            url:'/support-server/log/visit/homeCalculate',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
          })
          request({
            url: '/info/getImportVat',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
            data: {
              "countrySite": this.inputData.sellerInfo.input.countrySite.data
            }
          }).then(res => {
            if(res.data.code === 1){
              this.importVAT = res.data.info
              this.isUpdate = true
              this.show = true;
            }else if(res.data.code === 1001){
              this.show = true;
              this.isUpdate = true
            }
          }).catch(err => {
            console.log(err)
          })
        }

      },
      optionClick(index, i){
        this.inputData[index].input[i].isInput = true
        if(i == 'xxts'){
          this.clickmjgdfy1()
          if(this.inputData[index].input[i].data === 0){
            this.inputData.stockCost.input.sqbs.data = 1
            this.inputData.stockCost.input.importTariff.isDisable = false
          }else if(this.inputData[index].input[i].data === 1){
            this.inputData.stockCost.input.importTariff.data = 0
            this.inputData.stockCost.input.importTariff.isDisable = true
            this.inputData.stockCost.input.sqbs.data = 0
          }
        }
        if(this.inputData.sellerInfo.input.countrySite.data !== 0){
          this.inputData.sellerInfo.input.warehouseConfiguration.data = 0
          this.inputData.sellerInfo.input.warehouseConfiguration.isInput = true
          this.inputData.sellerInfo.input.warehouseConfiguration.isDisable = true
        }else {
          this.inputData.sellerInfo.input.warehouseConfiguration.isDisable = false
          this.inputData.sellerInfo.input.warehouseConfiguration.isInput = true
        }
        if(this.inputData.sellerInfo.input.countrySite.data !== '' && this.inputData.packData.input.sort.data !== '' &&
          this.inputData.sellerInfo.input.warehouseConfiguration.data.data !== '' && this.inputData.packData.input.long.data !== '' &&
          this.inputData.packData.input.width.data !== '' && this.inputData.packData.input.weight.data !== '' && this.inputData.packData.input.height.data !== ''){
          this.isUpdate = true
        }
        // if(this.inputData.sellerInfo.input.countrySite.data !== 0 && this.inputData.sellerInfo.input.countrySite.data !== 1 && this.inputData.sellerInfo.input.countrySite.data !== 8){
        //   this.inputData.stockCost.input.importTariff.isShow = true
        //   this.inputData.stockCost.input.saleTax.isShow = true
        //   this.inputData.sellerInfo.input.taxExpense.isShow = true
        // }else {
        //   this.inputData.stockCost.input.importTariff.isShow = false
        //   this.inputData.stockCost.input.saleTax.isShow = false
        //   this.inputData.sellerInfo.input.taxExpense.isShow = false
        // }

        if(i === 'sort' || i === 'warehouseConfiguration' || i === 'countrySite'){
          this.isUpdate = true
        }else {
          this.isUpdate = false
        }
      },
      // 取消弹窗
      cancelDialog(dialogShow){
        this.show = dialogShow
      },
      // 单位切换
      unitClick(){
        if(!this.unitIndex){
          if(this.inputData.packData.input.long.data !== ''){
            if((Math.round(this.aNum * 100) / 100).toFixed(2) === this.inputData.packData.input.long.data){
              this.inputData.packData.input.long.data = (Math.round(this.aNum * 0.393700787 * 100) / 100).toFixed(2)
            }else{
              this.aNum = this.inputData.packData.input.long.data * 0.393700787
              this.inputData.packData.input.long.data = (Math.round(this.aNum * 100) / 100).toFixed(2)
            }

            // this.inputData.packData.input.long.data = (Math.round(this.inputData.packData.input.long.data * 0.393700787 * 100) / 100).toFixed(2)
          }
          if(this.inputData.packData.input.width.data !== ''){
            if((Math.round(this.bNum * 100) / 100).toFixed(2) === this.inputData.packData.input.width.data){
              this.inputData.packData.input.width.data = (Math.round(this.bNum * 0.393700787 * 100) / 100).toFixed(2)
            }else{
              this.bNum = this.inputData.packData.input.width.data * 0.393700787
              this.inputData.packData.input.width.data = (Math.round(this.bNum * 100) / 100).toFixed(2)
            }
            // this.inputData.packData.input.width.data = (Math.round(this.inputData.packData.input.width.data * 0.393700787 * 100) / 100).toFixed(2)
          }
          if(this.inputData.packData.input.height.data !== ''){
            if((Math.round(this.cNum * 100) / 100).toFixed(2) === this.inputData.packData.input.height.data){
              this.inputData.packData.input.height.data = (Math.round(this.cNum * 0.393700787 * 100) / 100).toFixed(2)
            }else{
              this.cNum = this.inputData.packData.input.height.data * 0.393700787
              this.inputData.packData.input.height.data = (Math.round(this.cNum * 100) / 100).toFixed(2)
            }

            // this.inputData.packData.input.height.data = (Math.round(this.inputData.packData.input.height.data * 0.393700787 * 100) / 100).toFixed(2)
          }
          if(this.inputData.packData.input.weight.data !== ''){
            if((Math.round(this.dNum * 100) / 100).toFixed(2) === this.inputData.packData.input.weight.data){
              this.inputData.packData.input.weight.data = (Math.round(this.dNum * 2.20462262 * 100) / 100).toFixed(2)
            }else{
              this.dNum = this.inputData.packData.input.weight.data * 2.20462262
              this.inputData.packData.input.weight.data = (Math.round(this.dNum * 100) / 100).toFixed(2)
            }

            // this.inputData.packData.input.weight.data = (Math.round(this.inputData.packData.input.weight.data * 2.20462262 * 100) / 100).toFixed(2)
          }
        }else {
          if(this.inputData.packData.input.long.data !== ''){
            if((Math.round(this.aNum * 100) / 100).toFixed(2) === this.inputData.packData.input.long.data){
              this.inputData.packData.input.long.data = (Math.round(this.aNum * 2.54 * 100) / 100).toFixed(2)
            }else{
              this.aNum = this.inputData.packData.input.long.data * 2.54
              this.inputData.packData.input.long.data = (Math.round(this.aNum * 100) / 100).toFixed(2)
            }
            // this.inputData.packData.input.long.data = (Math.round(this.inputData.packData.input.long.data * 2.54 * 100) / 100).toFixed(2)
          }
          if(this.inputData.packData.input.width.data !== ''){
            if((Math.round(this.bNum * 100) / 100).toFixed(2) === this.inputData.packData.input.width.data){
              this.inputData.packData.input.width.data = (Math.round(this.bNum * 2.54 * 100) / 100).toFixed(2)
            }else{
              this.bNum = this.inputData.packData.input.width.data * 2.54
              this.inputData.packData.input.width.data = (Math.round(this.bNum * 100) / 100).toFixed(2)
            }

            // this.inputData.packData.input.width.data = (Math.round(this.inputData.packData.input.width.data * 2.54 * 100) / 100).toFixed(2)
          }
          if(this.inputData.packData.input.height.data !== ''){
            if((Math.round(this.cNum * 100) / 100).toFixed(2) === this.inputData.packData.input.height.data){
              this.inputData.packData.input.height.data = (Math.round(this.cNum * 2.54 * 100) / 100).toFixed(2)
            }else{
              this.cNum = this.inputData.packData.input.height.data * 2.54
              this.inputData.packData.input.height.data = (Math.round(this.cNum * 100) / 100).toFixed(2)
            }

            // this.inputData.packData.input.height.data = (Math.round(this.inputData.packData.input.height.data * 2.54 * 100) / 100).toFixed(2)
          }
          if(this.inputData.packData.input.weight.data !== ''){
            if((Math.round(this.dNum * 100) / 100).toFixed(2) === this.inputData.packData.input.weight.data){
              this.inputData.packData.input.weight.data = (Math.round(this.dNum * 0.45359237 * 100) / 100).toFixed(2)
            }else{
              this.dNum = this.inputData.packData.input.weight.data * 0.45359237
              this.inputData.packData.input.weight.data = (Math.round(this.dNum * 100) / 100).toFixed(2)
            }

            // this.inputData.packData.input.weight.data = (Math.round(this.inputData.packData.input.weight.data * 0.45359237 * 100) / 100).toFixed(2)
          }
        }
        this.unitIndex = (this.unitIndex + 1) % 2
        this.$emit('getUIndex', this.unitIndex)
      },
      //离开输入框后增加小数点
      clearNumber(value, index, i) {
        if(this.inputData[index].input[i].data !== ''){
          this.inputData[index].input[i].isInput = true
          if(parseFloat(this.inputData[index].input[i].data) < 0){ // 数据不能小于0
            alert(this.inputData[index].input[i].name + '数据有误')
            this.inputData[index].input[i].data = ''
          }else if(i === 'long' || i === 'width' || i === 'height' || i === 'weight' || i === 'stockNum' || i === 'stockPrice' || i === 'internationFreight' ||
            i === 'sellingPrice' || i === 'ListingNum'){
            if(parseFloat(this.inputData[index].input[i].data) === 0){
              alert(this.inputData[index].input[i].name+'不能为0')
              this.inputData[index].input[i].data = ''
              this.inputData[index].input[i].isInput = false
            }
          }
          if((i === 'long' || i === 'width' || i === 'height' || i === 'commission') && this.unitIndex === 0){ // 保留一位小数
            this.inputData[index].input[i].data = parseFloat(value).toFixed(1);
          }else if(i === 'stockNum' || i === 'domesticFreight' || i === 'internationFreight' || i === 'billingFee' ||
            i ==='drainageFee' || i === 'showSales' || i === 'disposalNum' || i === 'returnNum' || i === 'otherFee' ||
            i === 'positionDay' || i === 'ListingNum' || i === 'importTariff' || i === 'taxExpense'){ // 保留整数
            this.inputData[index].input[i].data = parseFloat(value).toFixed(0);
          }else if(i === 'operatingAnnualInterestRate' || i === 'recoveryLossRate'){
            this.inputData[index].input[i].data = parseFloat(value).toFixed(1);
          }else { // 保留两位小数
            this.inputData[index].input[i].data = parseFloat(value).toFixed(2);
          }
        }else if(this.inputData[index].input[i].data === ''){
          this.inputData[index].input[i].isInput = false
        }
      },
      selectBlur(value,index,i){
        if(this.inputData[index].input[i].data !== ''){
          this.inputData[index].input[i].isInput = true
        }
        if(this.inputData[index].input[i].data === ''){
          this.inputData[index].input[i].isInput = false
        }
      }
    },
    watch: {
      "inputData.sellerInfo.input.countrySite.data":{
        handler(newVal){
          let arr = [0, 1, 7]
          if(arr.includes(newVal)){
            // this.inputData.stockCost.input.xxts.isDisable = true
            this.inputData.stockCost.input.sqbs.isDisable = false
            this.inputData.stockCost.input.importTariff.isDisable = false
          }else{
            // this.inputData.stockCost.input.xxts.isDisable = false
            this.inputData.stockCost.input.sqbs.isDisable = true
            this.inputData.stockCost.input.importTariff.data = 0
            this.inputData.stockCost.input.importTariff.isDisable = true
          }
        },
        immediate: true
      },
      "inputData.stockCost.input.sqbs.data":{
        handler(newVal){
          if(!newVal){
            this.inputData.stockCost.input.importTariff.data = 0
            this.inputData.stockCost.input.importTariff.isDisable = true
          }else{
            this.inputData.stockCost.input.importTariff.isDisable = false
          }
        },
        immediate: true
      },
    }
  }
</script>

<style scoped lang="scss">
  .checkDia{
    position: absolute;
    right: 0px;
    color:#fff;
    padding: 3px;
    opacity: 0;
    // background-color: #19ACFD;
    &:hover{
      cursor: pointer;
      // opacity: .8;
    }
  }
  .question-img{
    width: 12px;
    position: absolute;
  }
  .input_module{
    float: left;
  }

  .bottom_end{
    justify-content: space-between;
  }

  .new_tips{
    color: #19acfd;
    margin: 10px 0;
    font-size: 16px;
    font-weight: 800;
    min-height: 50px;
    line-height: 50px;
  }

  .input_title{
    margin-bottom: 20px;
    color: black;
    font-weight: 600;
  }

  .input_content{
    margin: 10px 0;
  }

  .input_detail{
    display: flex;
    border: 1px solid #7f9db9;
    border-radius: 5px;
    overflow: hidden;
  }

  .input_text{
    border: none;
    outline: none;
    text-align: center;
    color: #7b7b7b;
  }

  .isInput{
    border: 1px solid red;
  }

  .isDisable{
    background-color: #eeeeee;
  }

  .input_icon{
    height: 20px;
    padding-top: 4px;
    color: #7b7b7b;
    text-align: center;
    z-index: 1;
  }

  .input_name_1, .input_name_2, .input_name_3, .input_name_4, .input_name_5{
    color: #000000;
    margin-top: 5px;
  }

  .special_icon{
    color: #1fa9ef;
  }

  .input_unit{
    margin-top: 5px;
  }

  .input_btn{
    background-color: #1c99fd;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    user-select: none;
  }

  .input_btn:hover{
    opacity: .7;
    cursor: pointer;
  }

  .select_text{
    border: none;
    outline: none;
    text-align: center;
    text-align-last: center;
    overflow: hidden;
    height: 20px;
    color: #7b7b7b;
  }

  .select_text:disabled{
    appearance: none;
  }

  .input_text:disabled{
    appearance: none;
    background-color: #eeeeee;
    z-index: 100;
  }

  .select_text1{
    margin: 2px 0 2px 3px;
    border: none;
    outline: none;
    text-align: center;
    text-align-last: start;
    overflow: hidden;
    height: 20px;
    color: #7b7b7b;
  }

  .calm_button{
    color: white;
    /* background-color: #0074bf; */
    background-color: rgb(45,154,228);
    border: none;
    /* border: 1px solid #07629e; */
    font-weight: bold;
    border-radius: 3px;
    outline: none;
  }

  .btn_right{
    /*min-height: 50px;*/
    float: right;
    text-align: end;
    /*right: 0;*/
  }

  .calm_button:hover{
    cursor: pointer;
    opacity: .8;
  }

  .curr_self{
    color: #19acfd;
    font-weight: 600;
  }

  .input_item_title{
    position: relative;
  }

  .input_item_detail{
    position: absolute;
    background-color: #dbedfc;
    /*margin-top: 50px;*/
    top: 25px;
    left: 0px;
    color: black;
    z-index: 10;
    line-height: 15px;
    border: 1px solid #a8a8a8;
    border-radius: 8px;
    padding: 5px;
  }

  .input_item_detail1{
    position: absolute;
    background-color: #dbedfc;
    /*margin-top: 50px;*/
    top: 25px;
    left: -400px;
    color: black;
    z-index: 10;
    line-height: 15px;
    border: 1px solid #a8a8a8;
    border-radius: 8px;
    padding: 5px;
  }

  .input_item_detail2{
    position: absolute;
    background-color: #dbedfc;
    color: black;
    top: -200px;
    /*left: 0px;*/
    /*margin: -6px 0 0 5px;*/
    margin: 25px 0 0 0;
    z-index: 10;
    width: 750px;
    font-size: 8px;
    line-height: 15px;
    border: 1px solid #a8a8a8;
    border-radius: 8px;
    padding: 5px;
  }

  .input_item_detail:after,.input_item_detail2:after{
    content: '';
    position: absolute;
    /*top: 20px;*/
    /*left: -6px;*/
    left: 8px;
    top: -6px;
    width: 10px;
    height: 10px;
    /*margin-top: -10px;*/
    margin-bottom: -10px;
    background: inherit;
    /*自动继承父元素的背景*/
    transform: rotate(45deg);
    border-left: 1px solid #a8a8a8;
    /*border-bottom: 1px solid #a8a8a8;*/
    border-top: 1px solid #a8a8a8;
  }

  .input_item_detail1:after{
    content: '';
    position: absolute;
    left: 408px;
    top: -6px;
    width: 10px;
    height: 10px;
    margin-bottom: -10px;
    background: inherit;
    /*自动继承父元素的背景*/
    transform: rotate(45deg);
    border-left: 1px solid #a8a8a8;
    border-top: 1px solid #a8a8a8;
  }

  .input_item_detail2:after{
    left: -6px;
    top: 174px;
    border-left: 1px solid #a8a8a8;
    border-bottom: 1px solid #a8a8a8;
    border-top: none;
  }

  .title_orange{
    color: #fca605;
  }

  .disable_text{
    font-size: 8px;
    padding-left: 9px;
    border: none;
    margin: 2px 0 2px 3px
  }

  @media screen and (max-width: 1600px) {
    .input_module{
      margin: 10px 1rem;
    }

    .input_title{
      font-size: 1.4rem;
    }

    .input_detail{
      width: 8rem;
    }

    .input_text{
      width: 6rem;
      height: 2rem;
      font-size: 1.2rem;
    }

    .input_icon{
      width: 1rem;
    }

    .input_name_1{
      width: 5.5rem;
    }

    .input_name_3{
      width: 10rem;
    }

    .input_name_2{
      width: 12rem;
    }

    .input_name_4{
      width: 10rem;
    }

    .input_name_5{
      width: 11rem;
    }

    .input_unit{
      margin-left: 0.1rem;
      width: 2.2rem;
      font-size: 1rem;
    }

    .input_btn{
      padding: 5px 0.4rem;
      margin-left: 0.4rem;
      font-size: 1rem;
    }

    .select_text{
      height: 2rem;
      width: 7rem;
      font-size: 1.2rem;
    }

    .select_text1{
      height: 1.67rem;
      width: 7.4rem;
      font-size: 1rem;
    }

    .disable_text{
      height: 1.67rem;
    }

    .calm_button{
      padding: 10px 1.8rem;
      margin: -5px 0.9rem 0px;
      font-size: 1.2rem;
    }

    .curr_self{
      font-size: 1rem;
    }

    .input_item_detail{
      margin: -6px 0 0 0.4rem;
      width: 55rem;
      font-size: 0.7rem;
    }

    .input_item_detail1{
      margin: -6px 0 0 0.4rem;
      width: 55rem;
      font-size: 0.7rem;
    }
  }

  @media screen and (min-width: 1600px){
    .input_module{
      margin: 10px 20px;
      font-size: 16px;
    }

    .input_title{
      font-size: 18px;
    }

    .input_detail{
      width: 100px;
    }

    .input_text{
      width: 70px;
      font-size: 14px;
      margin-left: 3px;
    }

    .input_icon{
      width: 10px;
      font-size: 14px;
      margin-top: -2px;
    }

    .input_name_1{
      width: 105px;
    }

    .input_name_3{
      width: 125px;
    }

    .input_name_2{
      width: 162px;
    }

    .input_name_4{
      width: 140px;
    }

    .input_name_5{
      width: 155px;
    }

    .input_unit{
      margin-left: 4px;
      width: 25px;
      font-size: 12px;
    }

    .input_btn{
      padding: 5px;
      margin-left: 5px;
      font-size: 12px;
    }

    .select_text{
      width: 100px;
      font-size: 14px;
    }

    .select_text1{
      width: 96px;
      font-size: 14px;
    }

    .calm_button{
      padding: 10px 20px;
      margin: 5px 10px;
      font-size: 16px;
    }

    .curr_self{
      font-size: 12px;
    }

    .input_item_detail{
      margin: -6px 0 0 5px;
      width: 650px;
      font-size: 12px;
    }

    .input_item_detail1{
      margin: -6px 0 0 5px;
      width: 650px;
      font-size: 12px;
    }

  }
</style>
